import { StatusBadge } from "@swot/base-components";
import type { EntityRecord } from "../../types/api.types.js";

export function isCmtsMasterDataRecordActive(record: EntityRecord | null | undefined): boolean {
  if (!record) return false;
  if (record.isActive === false || record.active === false) return false;
  const status = String(record.status ?? "Active").trim().toLowerCase();
  return status !== "inactive" && status !== "deactivated" && status !== "deleted" && status !== "archived";
}

export function cmtsMasterDataStatusLabel(record: EntityRecord | null | undefined): string {
  if (!record) return "Unknown";
  const status = String(record.status ?? "").trim();
  if (status) return status;
  return isCmtsMasterDataRecordActive(record) ? "Active" : "Inactive";
}

export function CmtsMasterDataStatusBadge({ record }: { readonly record: EntityRecord | null | undefined }) {
  const active = isCmtsMasterDataRecordActive(record);
  return <StatusBadge label={cmtsMasterDataStatusLabel(record)} tone={active ? "success" : "warning"} />;
}
